import React, { useState } from "react"
import CountUp from "react-countup"
import VisibilitySensor from "react-visibility-sensor"

interface CounterProps {
  className: string
  end: number
}

const getNumberWidth = (number: number) => {
  const numberString = number.toString()
  let numberWidth = numberString.length
  if (/[.,]+/.test(numberString)) {
    numberWidth += 0.5
  }
  return numberWidth
}

const Counter: React.FC<CounterProps> = ({ className, end }) => {
  const [viewPortEntered, setViewPortEntered] = useState(false)

  const easingFn = (t, b, c, d) => {
    const ts = (t /= d) * t
    const tc = ts * t
    return b + c * (tc + -3 * ts + 3 * t)
  }

  className = `${className} -number-width-${getNumberWidth(end)}`

  return (
    <CountUp
      end={end}
      start={viewPortEntered ? null : 0}
      duration={1.5}
      easingFn={easingFn}
    >
      {({ countUpRef }) => {
        return (
          <VisibilitySensor
            active={!viewPortEntered}
            onChange={isVisible => {
              if (isVisible) {
                setViewPortEntered(true)
              }
            }}
            delayedCall
          >
            <h3 className={className} ref={countUpRef} />
          </VisibilitySensor>
        )
      }}
    </CountUp>
  )
}

export default Counter
